export const objectToFormData = (
  object: any,
  removeUndefineds: boolean = false
): FormData => {
  let formData = new FormData();

  Object.keys(object).forEach((prop, _) => {
    const value = object[prop as keyof typeof object];
    if (value !== null && value !== undefined) {
      if (value instanceof File) {
        formData.append(prop, value);
      } else {
        if (value instanceof Date) {
          formData.append(prop, value.toLocaleDateString());
        } else {
          formData.append(prop, value.toString());
        }
      }
    } else {
      if (!removeUndefineds) {
        formData.append(prop, "");
      }
    }
  });

  return formData;
};

export const objectToFormDataWithNulls = (object: any): FormData => {
  let formData = new FormData();

  Object.keys(object).forEach((prop, _) => {
    const value = object[prop as keyof typeof object];
    if (value !== null && value !== undefined) {
      if (value instanceof File) {
        formData.append(prop, value);
      } else {
        if (value instanceof Date) {
          formData.append(prop, value.toLocaleDateString());
        } else {
          formData.append(prop, value.toString());
        }
      }
    } else {
      if (value === null) {
        formData.append(prop, "");
      }
    }
  });

  return formData;
};

export const objectToFormDataOptionalValues = (object: any): FormData => {
  let formData = new FormData();

  Object.keys(object).forEach((prop, _) => {
    const value = object[prop as keyof typeof object];
    if (value !== null && value !== undefined) {
      if (value instanceof File) {
        formData.append(prop, value);
      } else {
        if (value instanceof Date) {
          formData.append(prop, value.toLocaleDateString());
        } else {
          formData.append(prop, value.toString());
        }
      }
    }
  });

  return formData;
};
